<div class="split-button-group map-control-button-container" [class.hide-on-small-screens]="!!small_screens_icon">
  <button mat-flat-button
          (click)="cycleNextOption()"
          [tmTooltip]="getNextLabel()"
          [tmExplicitAriaLabel]="getCycleAriaLabel()"
          (keydown.enter)="cycleNextOption()"
          class="split-button-button cycle-button">
    {{ getLabel() }}
  </button>
  <button mat-flat-button
          [matMenuTriggerFor]="dropdownMenu"
          class="split-button-button drop-down-button"
          i18n-tmTooltip="@@core.background-layer-toggle.expand-button"
          tmTooltip="Select basemap"
          aria-label="Select basemap"
          i18n-aria-label="@@core.background-layer-toggle.expand-button">
    <mat-icon svgIcon="drop_down"></mat-icon>
  </button>
</div>

@if (small_screens_icon) {
  <div class="map-control-button-container">
    <button mat-flat-button
      class="map-control-button"
      [tmTooltip]="tooltip || ''"
      [matMenuTriggerFor]="dropdownMenu">
      <mat-icon [svgIcon]="small_screens_icon"></mat-icon>
    </button>
  </div>
}

<mat-menu #dropdownMenu="matMenu" class="options-menu">
  @for (option of optionsList; track option.id) {
    <button mat-menu-item
      class="split-button-menu-item"
      [aria-label]="option.label"
      [class.not-visible-in-3d]="isLayerHiddenOnMap(option)"
      (click)="selectOption(option.id)">
      <span [tmTooltip]="option.label"
            [matTooltipPosition]="'before'">
        @if (option.id === selectedOptionId) {
          <mat-icon svgIcon="check"></mat-icon>
        }
        {{ option.label }}
      </span>
    </button>
  }
</mat-menu>
